

























import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { FetchState } from "@/shared/types";
import { useCountryStore } from "@/shared/store/country";

@Component({})
export default class CountrySelector extends Vue {
  countryStore = useCountryStore();

  internalValue = "";

  @Prop()
  value: string;

  @Prop()
  isDisabled: boolean;

  @Prop()
  isInvalid: boolean;

  @Prop({ required: true })
  label: string;

  @Prop()
  excludeUnitedStates: boolean;

  get countryOptions () {
    return this.countryStore.countries
      .filter(country => !this.excludeUnitedStates || country.code !== "US")
      .map(country => ({
        value: country.code,
        text: country.name
      }));
  }

  get isLoaded () {
    return this.countryStore.fetchState === FetchState.Loaded;
  }

  @Watch("value")
  onValueChanged () {
    if (this.value) {
      this.internalValue = this.value;
    } else {
      this.internalValue = "";
    }
  }

  mounted () {
    this.countryStore.getCountries();
    this.internalValue = this.value || "";
  }

  updateValue (value: string) {
    this.$emit("input", value);
  }
}
